<template>
  <div class="wt-custom-overlay-field wt2-sg">
    <component
      ref="fieldComponent"
      :is="componentName"
      :field="field"
      :fieldDataModel="fieldDataModel"
      :stage-rect="stageRect"
      :allowStoryboardingControls="allowStoryboardingControls"
      @emmiter="onEvent"
      @storyboardingControlsChanged="onStoryboardingControlsChanged"
      @change="onValueChange"
    >
      <i
        v-if="field.tooltip"
        slot="tooltip"
        ref="tooltip"
        v-tooltip.extend="{
          title: field.tooltip,
          placement: 'right',
          delay: 300,
        }"
        class="wticon wticon-help-alt co-tooltip"
      />
      <storyboard-hint
        v-if="isStoryboard && field.type === 'MEDIA'"
        v-model="hint"
      />
    </component>

    <storyboard-hint
      v-if="allowStoryboardingControls && field.type !== 'MEDIA'"
      v-model="hint"
    />
  </div>
</template>

<script>
/**
 * Asset Editor's CustomOverlaysFieldContent
 */
import FieldText from 'AssetEditor/functionality/CustomOverlays/fields/FieldText.vue';
import FieldCheckbox from 'AssetEditor/functionality/CustomOverlays/fields/FieldCheckbox.vue';
import FieldColor from 'AssetEditor/functionality/CustomOverlays/fields/FieldColor.vue';
import FieldDropdown from 'AssetEditor/functionality/CustomOverlays/fields/FieldDropdown.vue';
import FieldNumber from 'AssetEditor/functionality/CustomOverlays/fields/FieldNumber.vue';
import FieldSeparator from 'AssetEditor/functionality/CustomOverlays/fields/FieldSeparator.vue';
import FieldArea from 'AssetEditor/functionality/CustomOverlays/fields/FieldArea.vue';
import FieldSlider from 'AssetEditor/functionality/CustomOverlays/fields/FieldSlider.vue';
import FieldMenuSlider from 'AssetEditor/functionality/CustomOverlays/fields/FieldMenuSlider.vue';
import FieldThumbnailGallery from 'AssetEditor/functionality/CustomOverlays/fields/FieldThumbnailGallery.vue';
import FieldSymbolGallery from 'AssetEditor/functionality/CustomOverlays/fields/FieldSymbolGallery.vue';
import FieldRadio from 'AssetEditor/functionality/CustomOverlays/fields/FieldRadio.vue';
import FieldPositionGrid from 'AssetEditor/functionality/CustomOverlays/fields/FieldPositionGrid.vue';
import FieldCompound from 'AssetEditor/functionality/CustomOverlays/fields/FieldCompound.vue';
import FieldMedia from 'AssetEditor/functionality/CustomOverlays/fields/FieldMedia.vue';
import StoryboardHint from 'AssetEditor/functionality/CustomOverlays/fields/StoryboardHint.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  props: {
    field: { type: Object, required: true },
    allowStoryboardingControls: { type: Boolean, default: false },
    stageRect: { type: DOMRect, required: false },
  },

  data() {
    return {
      fieldDataModel: undefined,
      hint: undefined,
    };
  },

  created() {
    this.fieldDataModel = _.clone(this.field?.fieldDataModel);
    this.hint = this.field?.fieldDataModel?.hint;
  },

  components: {
    StoryboardHint,
    FieldText,
    FieldCheckbox,
    FieldColor,
    FieldDropdown,
    FieldNumber,
    FieldSeparator,
    FieldArea,
    FieldPoint: FieldArea,
    FieldSlider,
    FieldMenuSlider,
    FieldThumbnailGallery,
    FieldSymbolGallery,
    FieldRadio,
    FieldPositionGrid,
    FieldCompound,
    FieldMedia,
  },

  computed: {
    ...mapGetters('assetEditor', ['currentPage']),
    ...mapState('assetEditor', ['isStoryboard']),

    componentName() {
      return 'field-' + (_.kebabCase(this.field.type) || '').toLowerCase();
    },
  },

  methods: {
    ...mapActions('assetEditor', ['ADD_OR_UPDATE_CUSTOM_OVERLAY_FIELD']),
    ...mapMutations('assetEditor', ['setTmpPageState']),

    onStoryboardingControlsChanged(valueChanged) {
      this.fieldDataModel[valueChanged.name] = valueChanged.value;
      const fieldDataModel = _.cloneDeep(this.fieldDataModel);
      this.ADD_OR_UPDATE_CUSTOM_OVERLAY_FIELD(
        Object.assign(
          {
            fieldDataModel,
            name: this.field.name,
            type: this.field.type,
          },
          {
            layers: this.currentPage.layers,
            id: this.currentPage.id,
          }
        )
      );
    },

    onValueChange({ valueChanges, makeDirty = true }) {
      if (makeDirty) {
        this.setTmpPageState({
          userInteractedWithPage: true,
        });
      }
      this.ADD_OR_UPDATE_CUSTOM_OVERLAY_FIELD(
        Object.assign(valueChanges, {
          layers: this.currentPage.layers,
          id: this.currentPage.id,
        })
      );
    },

    onEvent({ name, data }) {
      // propagate any event to parent
      this.$emit(name, data);
    },
  },

  watch: {
    hint() {
      this.onStoryboardingControlsChanged({
        name: 'hint',
        value: this.hint,
      });
    },
  },
};
</script>
